import { useRef } from "react";

const HoverVideo = ({src, preview} : {src? : string, preview: string}) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const handleMouseEnter = async () => {
    const video = videoRef.current;
    if (!video) return;

    try {
      await video.play();
    } catch (error) {
      // Ignore interrupted play requests
      if (error instanceof DOMException && error.name !== "AbortError") {
        console.error(error);
      }
    }
  };

  const handleMouseLeave = () => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  };

  return (
    <video
      ref={videoRef}
      muted
      playsInline
      poster={preview}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className="rounded-xl w-full h-full object-cover"
      loop
    >
      <source src={src} type="video/webm" />
    </video>
  );
}

export default HoverVideo;